/**
 * WebMCP 配置工具
 * 设置游戏参数（起始速度、起始行数、音效）
 */
/* eslint-disable */
var actions = require('../../actions').default;
var store = require('../../store').default;
var t = require('../lang').t;

/**
 * 配置游戏参数
 */
function configure(options) {
  options = options || {};
  var state = store.getState();
  var results = [];

  // 配置起始速度
  if (options.speedStart !== undefined) {
    var speed = options.speedStart;
    if (speed < 1) speed = 1;
    if (speed > 6) speed = 6;
    store.dispatch(actions.speedStart(speed));
    results.push('起始速度已设置为 ' + speed);
  }

  // 配置起始行数
  if (options.startLines !== undefined) {
    var lines = options.startLines;
    if (lines < 0) lines = 0;
    if (lines > 10) lines = 10;
    store.dispatch(actions.startLines(lines));
    results.push('起始行数已设置为 ' + lines);
  }

  // 配置音效
  if (options.music !== undefined) {
    store.dispatch(actions.music(options.music));
    results.push('音效已' + (options.music ? '开启' : '关闭'));
  }

  if (results.length === 0) {
    return {
      success: false,
      error: t('没有提供有效的配置参数', 'No valid configuration provided'),
    };
  }

  return {
    success: true,
    message: t('配置已更新', 'Configuration updated'),
    changes: results,
  };
}

/**
 * 获取当前配置
 */
function getConfiguration() {
  var state = store.getState();
  return {
    speedStart: state.get('speedStart'),
    startLines: state.get('startLines'),
    music: state.get('music'),
  };
}

/**
 * WebMCP 工具定义
 */
module.exports = {
  name: 'tetris_configure',
  description: t('配置游戏参数：起始速度(1-6)、起始行数(0-10)、音效开关', 'Configure game: start speed (1-6), start lines (0-10), sound on/off'),
  inputSchema: {
    type: 'object',
    properties: {
      speedStart: {
        type: 'number',
        description: t('起始速度，范围1-6，1最慢，6最快', 'Start speed, 1-6, 1 slowest, 6 fastest'),
        minimum: 1,
        maximum: 6,
      },
      startLines: {
        type: 'number',
        description: t('起始行数，范围0-10，0为空白，10为最满', 'Start lines, 0-10, 0 empty, 10 full'),
        minimum: 0,
        maximum: 10,
      },
      music: {
        type: 'boolean',
        description: t('是否开启音效', 'Enable sound effects'),
      },
    },
  },
  execute: function(args) {
    var result = configure(args);
    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify(result, null, 2),
        },
      ],
    });
  },
};

// 导出辅助函数
module.exports.configure = configure;
module.exports.getConfiguration = getConfiguration;



// WEBPACK FOOTER //
// ./src/webmcp/tools/configure.js